import React, { useState } from "react";
import './style.css';

const BASE_URL = "https://ckglobal.fw-12365.com/";

const STATUS_LABELS = {
  "合法": "Первая проверка",
  "重复": "Повторная проверка",
};

const AntiCounterfeitQuery = () => {
  const [code, setCode] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleQuery = async () => {
    if (!code) {
      setResult("Пожалуйста, введите защитный код.");
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const response = await fetch(
        `https://ckglobal.fw-12365.com/ashx/SecurityQueryApi.ashx?Key=tc201805051108&FWCode=${code}&Lang=en-gb`
      );
      const data = await response.json();
      setResult(data);
    } catch (error) {
      console.error("Query error:", error);
      setResult("Не удалось получить данные. Пожалуйста, попробуйте снова.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleQuery();
  };

  const isGenuine = result && typeof result === "object" && result.State !== undefined;

  return (
    <div className="acq-container">
      <h2 className="acq-title">Проверка подлинности</h2>

      <div className="acq-input-group">
        <input
          type="text"
          placeholder="Введите защитный код"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={handleKeyDown}
          className="acq-input"
        />
        <button onClick={handleQuery} disabled={loading} className="acq-button">
          {loading ? "..." : "Проверить"}
        </button>
      </div>

      {isGenuine && (
        <div className="acq-result">
          {result.BrandImg && (
            <div className="acq-brand">
              <img
                src={`${BASE_URL}${result.BrandImg}`}
                alt={result.BrandName}
                className="acq-brand-logo"
              />
            </div>
          )}

          <div className={`acq-status ${result.State === 1 ? "acq-status--ok" : "acq-status--warn"}`}>
            {result.State === 1 ? "✓ Оригинальный товар" : "⚠ Оригинальный, но проверялся ранее"}
          </div>

          <p className="acq-message">{result.QueryContent}</p>

          <div className="acq-meta">
            <div className="acq-meta-row">
              <span className="acq-meta-label">Бренд</span>
              <span>{result.BrandName}</span>
            </div>
            <div className="acq-meta-row">
              <span className="acq-meta-label">Код</span>
              <span>{result.BarCode}</span>
            </div>
            <div className="acq-meta-row">
              <span className="acq-meta-label">Первая проверка</span>
              <span>{result.FirstDate}</span>
            </div>
            <div className="acq-meta-row">
              <span className="acq-meta-label">Всего проверок</span>
              <span>{result.Times}</span>
            </div>
          </div>

          {result.RecordList && result.RecordList.length > 0 && (
            <div className="acq-history">
              <p className="acq-history-title">История проверок</p>
              {result.RecordList.map((rec) => (
                <div key={rec.ID} className="acq-history-item">
                  <span className={`acq-badge ${rec.Status === "合法" ? "acq-badge--ok" : "acq-badge--repeat"}`}>
                    {STATUS_LABELS[rec.Status] || rec.Status}
                  </span>
                  <span className="acq-history-date">{rec.QueryTime}</span>
                  <span className="acq-history-addr">{rec.Address}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {typeof result === "string" && (
        <p className="acq-error">{result}</p>
      )}
    </div>
  );
};

export default AntiCounterfeitQuery;
